import SignInForm from '@features/SignInForm/ui/SignInForm';
import usePageTitle from '@hooks/usePageTitle/usePageTitle';
import { useLoading } from '@providers/LoadingProvider/model/LoadingContext';
import { useEffect } from 'react';

/**
 * @description sign in page
 */

function SignInPage() {
  usePageTitle('ZlaytAI - Sign in');

  const { setLoading } = useLoading();
  useEffect(() => {
    setLoading(false);
  }, [setLoading]);
  return <SignInForm />;
}

export default SignInPage;
